import M from "jquery";
import { onBeforeUnmount as A, watch as T, onMounted as y, defineComponent as U, useCssVars as L, unref as r, computed as f, inject as D, ref as S, openBlock as C, createElementBlock as N, createElementVNode as o, renderSlot as E, createTextVNode as Y, toDisplayString as p, normalizeClass as O, createCommentVNode as q, Fragment as k, renderList as $, pushScopeId as Q, popScopeId as F } from "vue";
import { B as R, k as s, U as G, j as l } from "./NaturalCompare-BhqAyIXe.js";
import "utif2";
import './MessageBoxEx.css';const V = (c, d) => {
  const t = c.__vccOpts || c;
  for (const [n, a] of d)
    t[n] = a;
  return t;
};
function ve() {
  const c = [];
  function d(n, a) {
    var g, B;
    const m = new MutationObserver((v) => {
      v.forEach((I) => {
        t(M(I.target), a);
      });
    }), _ = {
      attributes: !0,
      attributeFilter: ["style"],
      characterData: !1,
      childList: !1,
      subtree: !1
    };
    m.observe(n, _);
    const h = M(n).closest(".modal, .collapse");
    0 < h.length ? (m.observe(h[0], _), (g = a == null ? void 0 : a.options) != null && g.immediate && t(h, a)) : (B = a == null ? void 0 : a.options) != null && B.immediate && t(M(n), a), c.push(m);
  }
  function t(n, a) {
    n.length <= 0 || (n.is(":hidden") ? a != null && a.onHidden && a.onHidden(n[0]) : a != null && a.onVisibled && a.onVisibled(n[0]));
  }
  return A(() => {
    c.forEach((n) => n.disconnect());
  }), {
    watchElementVisibility: d
  };
}
function Z(c, d) {
  T(d, () => {
    t(d.value);
  }), y(() => {
    t(d.value);
  });
  function t(a) {
    a ? R.showModal(c) : R.hideModal(c);
  }
  function n() {
    d.value = !1;
  }
  return {
    hideModal: n
  };
}
const K = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='a1908c24-145e-408e-856f-0d237994df40'%20data-name='レイヤー%205'%3e%3ccircle%20cx='120'%20cy='120'%20r='100'%20fill='%23c73e38'/%3e%3cpath%20d='M133.54858,120.00586l33.64551-33.65039A9.53053,9.53053,0,0,0,170,79.6001a9.67191,9.67191,0,0,0-2.80591-6.79395,9.58136,9.58136,0,0,0-13.5498,0L120,106.45508,86.35571,72.80615a9.581,9.581,0,0,0-13.5498,13.54932l33.64551,33.65039L72.80591,153.65625a9.581,9.581,0,0,0,13.5498,13.54932L120,133.55615l33.64429,33.64942a9.581,9.581,0,0,0,13.5498-13.54932Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", H = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='aaa9a38c-f573-4bce-9352-08642897a534'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='ff48341d-61fa-4f4d-959e-cd143a7c7c13'%20data-name='レイヤー%205'%3e%3cpath%20d='M132.5,177.41167a12.50031,12.50031,0,1,1-25,0,12.50031,12.50031,0,0,1,25,0Z'%20fill='%23fff'/%3e%3cpath%20d='M120,152a9.57967,9.57967,0,0,1-10-10v-3c0-6.77173.95947-16.64178,10.17432-24.52118,1.88672-1.61334,3.8081-3.17175,5.666-4.67889C136.42773,101.212,144.167,97.48175,144.167,88.28418,144.167,79.83075,141.19238,70,120,70c-8.55859,0-25,4-25,20,0,6.41663-4.24707,10.00006-10,10.00006s-10-4.6637-10-10.41669C75,65.90735,93.83154,50,120,50c36.16016,0,45,21.73151,45,38.28418,0,17.71582-14.99268,24.4256-26.03564,33.38275-1.83545,1.489-2.32076,1.852-3.96436,3.33307-2.8741,2.58993-5,7-5,14v3A9.57967,9.57967,0,0,1,120,152Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", j = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='b5278ebe-7d54-48f0-b5e3-60bac60958dc'%20data-name='レイヤー%205'%3e%3cpath%20d='M217.5,177.5,138.69654,41.17667a21.22945,21.22945,0,0,0-37.4125.02916L22.5,177.5a19.67288,19.67288,0,0,0-2.5,10A22.40645,22.40645,0,0,0,42.5,210h155A22.40645,22.40645,0,0,0,220,187.5,19.70264,19.70264,0,0,0,217.5,177.5Z'%20fill='%23fabe50'/%3e%3ccircle%20cx='120'%20cy='177.5'%20r='12.5'%20fill='%23493712'/%3e%3cpath%20d='M128.58154,143.77917C128.21071,147.295,124.46821,150,120.00238,150c-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94584C107.5,67,111.46667,60,120.00238,60,128.53571,60,132.5,67,132.5,74.83333,132.5,81,128.58154,143.77917,128.58154,143.77917Z'%20fill='%23493712'/%3e%3c/g%3e%3c/svg%3e", W = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='e55d3ae3-6a81-4989-920b-aa9ca8f4aa9b'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='b43da061-7bcf-45ee-a375-515d02cfa0ff'%20data-name='レイヤー%205'%3e%3ccircle%20cx='119.5'%20cy='62.5'%20r='12.5'%20fill='%23fff'/%3e%3crect%20x='107'%20y='90'%20width='25'%20height='100'%20rx='12.49999'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", z = (c) => (Q("data-v-1640fa82"), c = c(), F(), c), X = ["id"], J = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, P = { class: "modal-content modal-message-content-scv-cmn new-size" }, ee = { class: "modal-header modal-header-scv-cmn" }, te = { class: "modal-header-text-box-scv-cmn" }, se = { class: "modal-header-text-scv-cmn" }, ne = /* @__PURE__ */ z(() => /* @__PURE__ */ o("div", { class: "icon-font-slategray" }, [
  /* @__PURE__ */ o("i", { class: "icon-delete" })
], -1)), ae = [
  ne
], ce = { class: "modal-body modal-body-scv-cmn" }, oe = ["src"], le = ["innerHTML"], ie = { class: "modal-footer modal-footer-scv-cmn" }, de = ["id", "onClick"], re = /* @__PURE__ */ U({
  __name: "MessageBoxEx",
  props: {
    caption: { default: "" },
    flags: { default: s.MB_NO_BUTTON },
    message: { default: "" },
    show: { type: Boolean },
    uniqueButtonCaptions: { default: void 0 }
  },
  emits: ["update:show", "close"],
  setup(c, { emit: d }) {
    L((e) => ({
      "5b9a5fc9": r(x)
    }));
    const t = c, n = d, a = f(() => `messageBoxEx${G.NewID()}`), m = D("$show", S(null)), { hideModal: _ } = Z(a.value, f({
      get: () => m.value ?? t.show,
      set: (e) => n("update:show", e)
    })), h = f(() => {
      if (t.caption)
        return t.caption;
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
          return "エラー";
        case s.MB_ICONQUESTION:
          return "確認";
        case s.MB_ICONWARNING:
          return "警告";
        case s.MB_ICONINFORMATION:
          return "情報";
        default:
          return "";
      }
    }), g = [
      // [中止]
      {
        caption: "中止",
        handler: () => n("close", l.IDABORT),
        condition: (e) => s.MB_ABORTRETRYIGNORE === e
      },
      // [はい]
      {
        caption: "はい",
        handler: () => n("close", l.IDYES),
        condition: (e) => s.MB_YESNOCANCEL === e || s.MB_YESNO === e,
        styleClass: "btn-scv-blue"
      },
      // [いいえ]
      {
        caption: "いいえ",
        handler: () => n("close", l.IDNO),
        condition: (e) => s.MB_YESNOCANCEL === e || s.MB_YESNO === e
      },
      // [リトライ]
      {
        caption: "リトライ",
        handler: () => n("close", l.IDRETRY),
        condition: (e) => s.MB_RETRYCANCEL === e || s.MB_ABORTRETRYIGNORE === e,
        styleClass: "btn-scv-blue"
      },
      // [OK]
      {
        caption: "OK",
        handler: () => n("close", l.IDOK),
        condition: (e) => s.MB_OK === e || s.MB_OKCANCEL === e,
        styleClass: "btn-scv-blue"
      },
      // [キャンセル]
      {
        caption: "キャンセル",
        handler: () => n("close", l.IDCANCEL),
        condition: (e) => s.MB_OKCANCEL === e || s.MB_YESNOCANCEL === e || s.MB_RETRYCANCEL === e || s.MB_CANCELTRYCONTINUE === e
      },
      // [再実行]
      {
        caption: "再実行",
        handler: () => n("close", l.IDTRYAGAIN),
        condition: (e) => s.MB_CANCELTRYCONTINUE === e,
        styleClass: "btn-scv-blue"
      },
      // [続行]
      {
        caption: "続行",
        handler: () => n("close", l.IDCONTINUE),
        condition: (e) => s.MB_CANCELTRYCONTINUE === e,
        styleClass: "btn-scv-blue"
      },
      // [無視]
      {
        caption: "無視",
        handler: () => n("close", l.IDIGNORE),
        condition: (e) => s.MB_ABORTRETRYIGNORE === e
      },
      // [固有ボタン1]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[0] : "",
        handler: () => n("close", l.IDUNIQUE1),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 1 : !1,
        styleClass: "btn-scv-blue"
      },
      // [固有ボタン2]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[1] : "",
        handler: () => n("close", l.IDUNIQUE2),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 2 : !1
      },
      // [固有ボタン3]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[2] : "",
        handler: () => n("close", l.IDUNIQUE3),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 3 : !1
      }
    ], B = f(() => g.filter((i) => i.condition(t.flags & 15))), v = f(() => (e) => e.styleClass ? e.styleClass : "btn-scv-white"), I = f(() => {
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
        case s.MB_ICONQUESTION:
        case s.MB_ICONWARNING:
        case s.MB_ICONINFORMATION:
          return !0;
        default:
          return !1;
      }
    }), w = f(() => {
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
          return K;
        case s.MB_ICONQUESTION:
          return H;
        case s.MB_ICONWARNING:
          return j;
        case s.MB_ICONINFORMATION:
          return W;
        default:
          return "";
      }
    }), x = f(() => !t.message || 1 < t.message.replace(/\r?\n/g, "<br />").split("<br />").length ? "start" : "center");
    return y(() => {
      const e = t.flags >> 8 & 15;
      if (e != s.MB_NO_DEFBUTTON) {
        const i = document.getElementById(a.value), u = i == null ? void 0 : i.querySelector("#messageBoxEXbutton" + e);
        i == null || i.addEventListener("shown.bs.modal", () => {
          u == null || u.focus();
        });
      }
    }), (e, i) => (C(), N("div", {
      class: "modal fade",
      id: r(a),
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      o("div", J, [
        o("div", P, [
          o("div", ee, [
            o("div", te, [
              o("div", se, [
                E(e.$slots, "title", {}, () => [
                  Y(p(r(h)), 1)
                ], !0)
              ])
            ]),
            o("a", {
              class: "btn-scv-cmn-close",
              onClick: i[0] || (i[0] = (u) => {
                r(_)(), n("close", r(l).IDCANCEL);
              })
            }, ae)
          ]),
          o("div", ce, [
            o("div", {
              class: O(e.$style.body)
            }, [
              r(I) ? (C(), N("img", {
                key: 0,
                src: r(w),
                height: "24"
              }, null, 8, oe)) : q("", !0),
              o("div", null, [
                E(e.$slots, "default", {}, () => [
                  o("div", {
                    innerHTML: t.message
                  }, null, 8, le)
                ], !0)
              ])
            ], 2)
          ]),
          o("div", ie, [
            E(e.$slots, "footer", {}, () => [
              o("div", {
                class: O(e.$style.footer)
              }, [
                (C(!0), N(k, null, $(r(B), (u, b) => (C(), N("button", {
                  key: b,
                  id: "messageBoxEXbutton" + (b + 1),
                  class: O(r(v)(u)),
                  onClick: (he) => {
                    r(_)(), u.handler();
                  }
                }, p(u.caption), 11, de))), 128))
              ], 2)
            ], !0)
          ])
        ])
      ])
    ], 8, X));
  }
}), ue = "_body_1c8kf_5", fe = "_footer_1c8kf_45", me = {
  body: ue,
  footer: fe
}, _e = {
  $style: me
}, Ie = /* @__PURE__ */ V(re, [["__cssModules", _e], ["__scopeId", "data-v-1640fa82"]]);
export {
  Ie as M,
  V as _,
  Z as a,
  ve as u
};
